import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube } from "lucide-react";
import { Newsletter } from "@/components/Newsletter";

const COLS = [
  {
    title: "Shop",
    id: "shop",
    links: [
      { label: "Men", to: "/shop?cat=men" },
      { label: "Women", to: "/shop?cat=women" },
      { label: "New Arrivals", to: "/shop?tag=new" },
      { label: "Best Sellers", to: "/shop?tag=best" },
      { label: "Collections", to: "/#collections" },
    ],
  },
  {
    title: "Help",
    id: "help",
    links: [
      { label: "Contact", to: "/#story" },
      { label: "Shipping", to: "/shop" },
      { label: "Returns", to: "/shop" },
      { label: "FAQ", to: "/shop" },
      { label: "Size Guide", to: "/shop" },
    ],
  },
  {
    title: "Company",
    id: "company",
    links: [
      { label: "About", to: "/#story" },
      { label: "Our Story", to: "/#story" },
      { label: "Careers", to: "/#story" },
      { label: "Community", to: "/community" },
    ],
  },
];

const SOCIALS = [
  { label: "Instagram", icon: Instagram, id: "instagram" },
  { label: "TikTok", icon: null, id: "tiktok" },
  { label: "Facebook", icon: Facebook, id: "facebook" },
  { label: "YouTube", icon: Youtube, id: "youtube" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-stone/10 bg-abyss overflow-hidden">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 pt-20 pb-10 relative z-10">
      <div className="grid grid-cols-2 md:grid-cols-12 gap-10 md:gap-8">
        <div className="col-span-2 md:col-span-4">
          <img src="/assets/brand/logo-mark.svg" alt="MVM" className="h-10 mb-6" />
          <p className="text-stone/50 text-sm leading-relaxed max-w-xs">
            Premium apparel representing discipline, resilience and the Me vs Me mindset. Built for performance.
            Designed for everyday.
          </p>
          <div className="mt-8">
            <p className="text-xs tracking-[0.25em] uppercase text-stone/40 mb-4">Stay in motion</p>
            <Newsletter compact />
          </div>
        </div>

        {COLS.map((col) => (
          <div key={col.id} className="md:col-span-2">
            <h3 className="text-xs tracking-[0.25em] uppercase text-stone/40 mb-5">{col.title}</h3>
            <ul className="space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-${col.id}-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-stone/70 hover:text-mist transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="md:col-span-2">
          <h3 className="text-xs tracking-[0.25em] uppercase text-stone/40 mb-5">Social</h3>
          <ul className="space-y-3">
            {SOCIALS.map((s) => (
              <li key={s.id}>
                <a
                  href="#"
                  data-testid={`footer-social-${s.id}`}
                  onClick={(e) => e.preventDefault()}
                  className="text-sm text-stone/70 hover:text-mist transition-colors inline-flex items-center gap-2"
                >
                  {s.icon && <s.icon size={14} />} {s.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-stone/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-stone/40">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} MVM Athletics. All rights reserved.</p>
        <div className="flex gap-6">
          <a href="#" data-testid="footer-privacy" onClick={(e) => e.preventDefault()} className="hover:text-stone transition-colors">Privacy Policy</a>
          <a href="#" data-testid="footer-terms" onClick={(e) => e.preventDefault()} className="hover:text-stone transition-colors">Terms</a>
          <a href="#" data-testid="footer-accessibility" onClick={(e) => e.preventDefault()} className="hover:text-stone transition-colors">Accessibility</a>
        </div>
      </div>
    </div>

    <div aria-hidden="true" className="pointer-events-none select-none relative -mb-[4vw]">
      <p className="font-display font-bold uppercase text-center leading-none text-[26vw] text-outline opacity-40 tracking-tight">
        MVM
      </p>
    </div>
  </footer>
);
